import React, { createContext, useContext } from 'react';

const AdminEmailContext = createContext(null);

export const AdminEmailProvider = ({ value, children }) => (
  <AdminEmailContext.Provider value={value}>{children}</AdminEmailContext.Provider>
);

export const useAdminEmail = () => {
  const ctx = useContext(AdminEmailContext);
  if (!ctx) {
    throw new Error('useAdminEmail must be used within AdminEmailProvider');
  }
  return ctx;
};

export default AdminEmailContext;
